var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryRs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_8540)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_8540",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_8540)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.3333H28V6.66663H0V13.3333Z",
    fill: "#17508F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.66667H28V0H0V6.66667Z",
    fill: "#E1444D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9.99996C6 9.3549 6.34366 7.9178 6.5375 7.15853C6.61181 6.86747 6.87495 6.66663 7.17534 6.66663H10.1592C10.459 6.66663 10.7218 6.86667 10.7964 7.15706C10.9903 7.91191 11.3333 9.34016 11.3333 9.99996C11.3333 10.7449 10.833 12.7007 10.6992 13.2104C10.6777 13.2924 10.6412 13.3676 10.5872 13.433C10.3317 13.7425 9.49918 14.6666 8.66667 14.6666C7.83364 14.6666 7.00061 13.7414 6.74565 13.4324C6.69202 13.3674 6.65559 13.2927 6.63405 13.2112C6.50018 12.7052 6 10.7634 6 9.99996Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2858_8540",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 6,
    height: 9
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9.99996C6 9.3549 6.34366 7.9178 6.5375 7.15853C6.61181 6.86747 6.87495 6.66663 7.17534 6.66663H10.1592C10.459 6.66663 10.7218 6.86667 10.7964 7.15706C10.9903 7.91191 11.3333 9.34016 11.3333 9.99996C11.3333 10.7449 10.833 12.7007 10.6992 13.2104C10.6777 13.2924 10.6412 13.3676 10.5872 13.433C10.3317 13.7425 9.49918 14.6666 8.66667 14.6666C7.83364 14.6666 7.00061 13.7414 6.74565 13.4324C6.69202 13.3674 6.65559 13.2927 6.63405 13.2112C6.50018 12.7052 6 10.7634 6 9.99996Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2858_8540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 7.33329L5.99992 14",
    stroke: "#E1444D",
    strokeWidth: 1.33333,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7.33329L11.3333 14",
    stroke: "#E1444D",
    strokeWidth: 1.33333,
    strokeLinecap: "square"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_8540"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryRs);
export default __webpack_public_path__ + "static/media/Country=RS.f7d450301d70fc8633c876568c8e8ea4.svg";
export { ForwardRef as ReactComponent };